export default __webpack_public_path__ + "static/media/refer-and-earn.aa9c9b4d.svg";